<script lang="ts">
  import { fade } from "svelte/transition";
  import { portal } from "../../actions/portal";
  import ModalUnderlay from "./ModalUnderlay.svelte";
  import { createModal, type ModalPartAttributes } from "./createModal";
  import { DEFAULT_FADE_TRANSITION } from "./transitions";

  export let open: boolean;
  export let underlayAttrs: ModalPartAttributes;
  export let contentAttrs: ModalPartAttributes;
  export let contentAction: ReturnType<typeof createModal>["content"];
  export let backgroundImage: string | undefined = undefined;
  export let aspectRatio: string | undefined = "4 / 3";
</script>

<div use:portal style:--bg-image="url({backgroundImage})">
  {#if open}
    <ModalUnderlay {...underlayAttrs} />
    <div
      class="modal-content"
      {...contentAttrs}
      use:contentAction
      transition:fade|global={DEFAULT_FADE_TRANSITION}
      style:aspect-ratio={aspectRatio}
    >
      <div class="modal-content-layout">
        <slot name="leftPanel" />
        <slot name="rightPanel" />
      </div>
    </div>
  {/if}
</div>

<style>
  .modal-content {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 50;
    border-radius: var(--rk-rounding-l);
    width: 90vw;
    max-width: 960px;
    transform: translate(-50%, -50%);
    background-image: var(--bg-image);
    background-size: cover;
    background-color: #070b11;
  }

  .modal-content-layout {
    display: flex;
    height: 100%;
  }
</style>
